import {lazy} from 'react';

const LoginForm = lazy(() => import('views/pages/auth/LoginForm.js'));

const routes = [

  {
    collapse: true,
    name: "Examples",
    module:"login",
    icon: "ni ni-ungroup text-orange",
    state: "examplesCollapse",
    views: [

      {
        path: "/login",
        name: "login",
        miniName: "L",
        component: LoginForm,
        layout: "/auth"
      }
    ]
  }
  
];

export default routes;
